var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgC04Faq(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.34 20.99",
    width: "1em",
    height: "1em",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0089fb;}.cls-2,.cls-3{fill:none;stroke:#0089fb;stroke-miterlimit:10;stroke-width:1.45px;}.cls-3{stroke-linecap:square;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_1-2",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8,8.7H6.71a2.27,2.27,0,0,1,.07-.86,2.05,2.05,0,0,1,.88-1.2A.66.66,0,0,0,8,5.84a.65.65,0,0,0-.68-.46A.68.68,0,0,0,6.7,6H5.37a1.79,1.79,0,0,1,.14-.73A2,2,0,0,1,7.44,4,2,2,0,0,1,9.3,5.51,2,2,0,0,1,8.48,7.7.89.89,0,0,0,8,8.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8,9.39V10.7H6.71V9.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.3,14H.72V7.37A6.65,6.65,0,0,1,7.37.72h0A6.64,6.64,0,0,1,14,7.37h0a6.64,6.64,0,0,1-5.35,6.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "7.37 14.01 3.05 12.25 4.07 14.01 3.05 15.78 7.37 14.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.58,12.52a1.36,1.36,0,0,0,.28,2.71,1.36,1.36,0,1,0-.28-2.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M16.71,7.21a6.45,6.45,0,0,1,2.95,1.71,6.6,6.6,0,0,1,1.95,4.7v6.64H15a6.6,6.6,0,0,1-5.6-3.08"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC04Faq);
export default __webpack_public_path__ + "static/media/C04_FAQ.7d14a2c249c1ff162ab2bf0eaac2481f.svg";
export { ForwardRef as ReactComponent };